__webpack_require__.p = "https://d1v596tjbbwtf3.cloudfront.net/learning/";